import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpService } from './http.service';
import { EndPoint } from '../config/endpoint';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SubjectService {
  constructor(private httpService: HttpService) {}

  async getAllSubjects() {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.Subject}`),
      );
      return this.httpService.decodeUserToken(response);
    } catch (error) {
      throw error;
    }
  }

  async getSubjectByID(id: number) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.Subject}/${id}`),
      );
      return this.httpService.decryptToken(response);
    } catch (error) {
      throw error;
    }
  }

  async getSubjectsByIds(body) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.SubjectByIDs}`, body),
      );
      return this.httpService.decodeToken(response);
    } catch (error) {
      throw error;
    }
  }
}
